<template>
    <div id="gauge-chart">
        <v-chart :options="graph"/>
        <div @click="notify()" class="notification"><md-icon >info</md-icon></div>
    </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'


export default {
  name: 'gauge',
  components: {'v-chart': ECharts},
  props: ['name','min','max','value','infoMessage'],

  data() {
    return {
      graph : {
        tooltip : {
          formatter: "{a} <br/>{b} : {c}%"
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888',
        },
        title: {
          text: this.name,
          textStyle: {
            fontSize: 13
          }
        },
        series: [
          {
            name: 'EFICIENCIA',
            type: 'gauge',
            startAngle: 210,
            endAngle:-30,
            min: this.min,
            max: this.max,
            center: ['50%','60%'],
            axisLabel: {
              show:true,
              fontSize:'12px',
              padding: -12
            },
            title: {
              show: false,
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle :{
                width: 13,
                color:[[0.2, '#c23531'], [0.8, '#63869e'], [1, '#91c7ae']],
              },

            },
            pointer: {
              width:4
            },
            radius: '90%',
            splitNumber: 5,
            detail: {
              formatter:'{value}%',
              fontSize: 28
            },
            data: [{value: this.value, name: this.name}]
          }
        ]
      }
    }
  },
  methods: {
    notify() {
      this.$notify(
        {
          message: this.infoMessage,
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'default',
        })
    },
    modifyChartInMobileView() {
      if (window.screen.width < 600) {
        this.graph.series[0].axisLine.lineStyle.width = 8;
        this.graph.series[0].axisLabel.padding = -18;
        this.graph.series[0].detail.fontSize = 20;
        this.graph.series[0].center =  ['50%','52%'];
      }
    },
  },
  mounted(){
    this.modifyChartInMobileView();
  }
}
</script>
<style>
#gauge-chart{position: relative}
.notification{
    position:absolute;
    bottom:15%;
    cursor:pointer;

}
#gauge-chart .echarts { width: 100%; height: 200px !important;  /* or e.g. 400px */ }

</style>


